import { render, staticRenderFns } from "./SliderVcDemo.vue?vue&type=template&id=3ad8954e&scoped=true&"
import script from "./SliderVcDemo.vue?vue&type=script&lang=js&"
export * from "./SliderVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./SliderVcDemo.vue?vue&type=style&index=0&id=3ad8954e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8954e",
  null
  
)

export default component.exports